import { REGIONS } from 'state/intl/types';

export const domainChangeByRegion = (url: string, regionKey?: REGIONS) => {
  if (regionKey === REGIONS.CA && !window.location.hostname.includes('popeyeschicken')) {
    return url.replace('popeyes', 'popeyeschicken');
  }
  if (regionKey === REGIONS.US && window.location.hostname.includes('popeyes.com')) {
    return url.replace('popeyeschicken', 'popeyes');
  }
  return url;
};
